import { Text } from '@chakra-ui/react'
import React from 'react'

const NotAvailable = () => {
    return (
        <Text as="span" fontSize="xs" color="gray.400">-- NA --</Text>
    )
}

export default NotAvailable